import { render, staticRenderFns } from "./ProductionItems.vue?vue&type=template&id=56cf836a&"
import script from "./ProductionItems.vue?vue&type=script&lang=js&"
export * from "./ProductionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports